import { assertNotNullOrUndefined } from 'record-it-utils/utils/assert/assertNotNullOrUndefined';
import { useAppSelector } from '../../store/hooks';
import { WorkTimeEntryToCreate } from '../../store/slice/createWorkTimeEntry/createWorkTimeEntrySlice';
export function useRequiredWorkTimeEntryToCreate() {
  const workTimeEntryToCreate = useAppSelector(_temp);
  assertNotNullOrUndefined(workTimeEntryToCreate, "the createWorkTimeEntry has not been started");
  return workTimeEntryToCreate;
}
function _temp(state) {
  return state.createWorkTimeEntry.workTimeEntryToCreate;
}